export default __webpack_public_path__ + "static/Polymer-35556d0c7b19841cdfaf5713d1f3e8d5.png";